module.exports = __webpack_public_path__ + "static/wsc_logo_new-120d32daa26cb37cc5e895a264570865.png";